import { render, staticRenderFns } from "./CreateBulkBtn.vue?vue&type=template&id=1a199e08"
import script from "./CreateBulkBtn.vue?vue&type=script&lang=ts"
export * from "./CreateBulkBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports